import Swiper, { Pagination } from 'swiper';

const publications = {
	ui: {},

	init: function() {
		this.initSlider();
	},

	initSlider: function initSlider() {
		
        const sliderEl = document.querySelector('.js-blogcard-list-mobile');

        const swiperInst = new Swiper(sliderEl, {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 30,
            modules: [Pagination],
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        })

	},

};

export default publications;
